import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { defaultNS, resources } from './recources';

// English by default; CIS languages fall back to Russian. Missing English keys
// fall back to Russian too, as it is the only complete dictionary.
const CIS_FALLBACK = ['ru'];
const FALLBACK_LNG = {
  am: CIS_FALLBACK,
  az: CIS_FALLBACK,
  kg: CIS_FALLBACK,
  kz: CIS_FALLBACK,
  tj: CIS_FALLBACK,
  uz: CIS_FALLBACK,
  default: ['en', 'ru'],
};

// Our locale keys for these languages are country codes; browsers send ISO 639-1.
// The keys are not renamed on purpose: merchants already pass them in `?lng=`,
// customers have them cached in localStorage (`i18nextLng`), and the language
// selector builds the flag icon class from the code (`fi-kr`, `fi-ua`, ...).
// So we map ISO codes to our keys on detection and back to ISO for <html lang>.
const ISO_TO_LOCALE: Record<string, string> = {
  hy: 'am',
  id: 'idn',
  ka: 'ge',
  kk: 'kz',
  ko: 'kr',
  ky: 'kg',
  tg: 'tj',
  uk: 'ua',
};

const LOCALE_TO_ISO: Record<string, string> = Object.fromEntries(
  Object.entries(ISO_TO_LOCALE).map(([iso, locale]) => [locale, iso]),
);

// CIS languages we have no translation for: show Russian instead of the English default.
const UNTRANSLATED_TO_LOCALE: Record<string, string> = {
  be: 'ru',
  tk: 'ru',
};

export const convertDetectedLanguage = (lng: string): string => {
  const [language] = lng.toLowerCase().split(/[-_]/);
  return (
    ISO_TO_LOCALE[language] ?? UNTRANSLATED_TO_LOCALE[language] ?? language
  );
};

export const toHtmlLang = (locale: string): string =>
  LOCALE_TO_ISO[locale] ?? locale;

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = toHtmlLang(i18n.resolvedLanguage ?? lng);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LNG,
    supportedLngs: Object.keys(resources),
    detection: { convertDetectedLanguage },
    defaultNS,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });
